import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * RefundsApiService (Angular 18) — POST endpoints for refunds and refund previews.
 *
 * Replaces apps/b2b-ui/common/services/api/refundsApi/refundsApi.service.js.
 */
const REFUNDS_BASE = "/v1/api/b2b/refunds";

@Injectable({ providedIn: "root" })
export class RefundsApiService {
  private readonly http = inject(HttpClient);

  refund(refundObject: unknown): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.post<unknown>(REFUNDS_BASE, refundObject));
  }

  previewRefund(refundObject: unknown): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.post<unknown>(`${REFUNDS_BASE}/preview`, refundObject));
  }
}
